import React from "react";
import { bool, number, shape } from "prop-types";
import { Pagination } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

const Paginator = ({ data }) => {
  const { TotalPages, HasPrevious, HasNext } = data;
  // state

  // variables
  const pages = Array.from(Array(TotalPages + 1).keys()).slice(1);
  const offset = 3;

  // logics before hooks

  // hooks
  const [searchParams, setSearchParams] = useSearchParams();
  const CurrentPage = parseInt(searchParams.get("PageNumber")) || 1;

  // logics
  const goToPage = (page) => {
    searchParams.set("PageNumber", page);
    setSearchParams(searchParams);
  };

  // UI partials

  // effects

  // render
  if (TotalPages === 0) return null;
  return (
    <Pagination className="m-0">
      <Pagination.First
        disabled={CurrentPage === 1}
        onClick={() => goToPage(1)}
      />
      <Pagination.Prev
        disabled={!HasPrevious}
        onClick={() => goToPage(CurrentPage - 1)}
      />
      {pages.map((page, index) => {
        if (page === CurrentPage - offset || page === CurrentPage + offset)
          return <Pagination.Ellipsis key={index} />;
        if (page > CurrentPage - offset && page < CurrentPage + offset)
          return (
            <Pagination.Item
              key={index}
              active={page === CurrentPage}
              onClick={() => goToPage(page)}
            >
              {page}
            </Pagination.Item>
          );
        return null;
      })}
      <Pagination.Next
        disabled={!HasNext}
        onClick={() => goToPage(CurrentPage + 1)}
      />
      <Pagination.Last
        disabled={CurrentPage === TotalPages}
        onClick={() => goToPage(TotalPages)}
      />
    </Pagination>
  );
};

/* required: display name */
Paginator.displayName = "Paginator";

/* required: props types */
Paginator.propTypes = {
  data: shape({
    TotalPages: number,
    HasPrevious: bool,
    HasNext: bool,
  }),
};

/* required: default props */
Paginator.defaultProps = {
  data: {
    TotalPages: 1,
    HasPrevious: false,
    HasNext: false,
  },
};

export { Paginator };
